import React, { Component } from 'react'
import { throttle } from 'lodash'

export const withResize = (WrappedComponent, breakpoints = {}) => {
  const BREAKPOINTS_CONFIG = {
    mobile: 1024,
    large: 1440,
    ...breakpoints,
  }

  return class extends Component {
    state = {
      isMobile: window.innerWidth < BREAKPOINTS_CONFIG.mobile ,
      isDesktop: window.innerWidth > BREAKPOINTS_CONFIG.mobile && window.innerWidth < BREAKPOINTS_CONFIG.large,
      isLarge: window.innerWidth > BREAKPOINTS_CONFIG.large ,
    }

    componentDidMount() {
      this.resize = window.addEventListener('resize', this.onResize.bind(this))
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize.bind(this))
    }

    onResize = throttle(() => {
      this.setState({
        isMobile: window.innerWidth < BREAKPOINTS_CONFIG.mobile ,
        isDesktop: window.innerWidth > BREAKPOINTS_CONFIG.mobile && window.innerWidth < BREAKPOINTS_CONFIG.large,
        isLarge: window.innerWidth > BREAKPOINTS_CONFIG.large ,
      })
    }, 400)

    render() {
      return <WrappedComponent viewport={this.state} {...this.props} />;
    }
  }
}


// WEBPACK FOOTER //
// ./src/hoc/withResize.js